import Vue, { defineAsyncComponent } from "vue"

// Global components
// ==============================================

const Loader = defineAsyncComponent(() => import(/* webpackChunkName:'Loader' */ './Loader/Loader.vue'))
const Base = defineAsyncComponent(() => import(/* webpackChunkName:'Base' */ './Base.vue'))
const Navigation = defineAsyncComponent(() => import(/* webpackChunkName:'Navigation' */ './Navigation/Navigation.vue'))
const Header = defineAsyncComponent(() => import(/* webpackChunkName:'Header' */ './Header.vue'))
const PersonaFull = defineAsyncComponent(() => import(/* webpackChunkName:'PersonaFull' */ './PersonaFull.vue'))
const Footer = defineAsyncComponent(() => import(/* webpackChunkName:'Footer' */ './Footer.vue'))
const MoodboardNotification = defineAsyncComponent(() => import(/* webpackChunkName:'MoodboardNotification' */ './MoodboardNotification/MoodboardNotification.vue'))

// Dynamic reusable components
// ==============================================

// import Accordion from "./Accordions/Accordion"
// import AccordionItem from "./Accordions/AccordionItem"
const ContactForm = defineAsyncComponent(() => import(/* webpackChunkName:'ContactForm' */ './Forms/ContactForm.vue'))
const ContactFormSalesforce = defineAsyncComponent(() => import(/* webpackChunkName:'ContactFormSalesforce' */ './Forms/ContactFormSalesforce.vue'))
const SignUpForm = defineAsyncComponent(() => import(/* webpackChunkName:'SignUpForm' */ './Forms/SignUpForm.vue'))
const UserForm = defineAsyncComponent(() => import(/* webpackChunkName:'UserForm' */ './Forms/UserForm.vue'))
const SampleForm = defineAsyncComponent(() => import(/* webpackChunkName:'SampleForm' */ './Forms/SampleForm.vue'))
const MagazineForm = defineAsyncComponent(() => import(/* webpackChunkName:'MagazineForm' */ './Forms/MagazineForm.vue'))
const ColourDrawer = defineAsyncComponent(() => import(/* webpackChunkName:'ColourDrawer' */ './Drawers/ColourDrawer.vue'))
const ProductDrawer = defineAsyncComponent(() => import(/* webpackChunkName:'ProductDrawer' */ './Drawers/ProductDrawer.vue'))
const Card = defineAsyncComponent(() => import(/* webpackChunkName:'Card' */ './Cards/Card.vue'))
const SampleCard = defineAsyncComponent(() => import(/* webpackChunkName:'SampleCard' */ './Cards/SampleCard.vue'))
const SampleSolutionCard = defineAsyncComponent(() => import(/* webpackChunkName:'SampleSolutionCard' */ './Cards/SampleSolutionCard.vue'))
const Colour = defineAsyncComponent(() => import(/* webpackChunkName:'Colour' */ './Colour.vue'))
const ColourCard = defineAsyncComponent(() => import(/* webpackChunkName:'ColourCard' */ './Cards/ColourCard.vue'))
const SampleColourCard = defineAsyncComponent(() => import(/* webpackChunkName:'SampleColourCard' */ './Cards/ColourCard.vue'))
const Cta = defineAsyncComponent(() => import(/* webpackChunkName:'Cta' */ './Cta/Cta.vue'))
const ModalInfo = defineAsyncComponent(() => import(/* webpackChunkName:'ModalInfo' */ './Modal/ModalInfo.vue'))
const ModalShare = defineAsyncComponent(() => import(/* webpackChunkName:'ModalShare' */ './Modal/ModalShare.vue'))
const ModalFullpage = defineAsyncComponent(() => import(/* webpackChunkName:'ModalFullpage' */ './Modal/ModalFullpage.vue'))
const SliderHorizontal = defineAsyncComponent(() => import(/* webpackChunkName:'SliderHorizontal' */ './Sliders/SliderHorizontal.vue'))
const SliderVertical = defineAsyncComponent(() => import(/* webpackChunkName:'SliderVertical' */ './Sliders/SliderVertical.vue'))

// Silverstripe elemental components
// ==============================================
const ElementAccordion = defineAsyncComponent(() => import(/* webpackChunkName 'ElementAccordion': */ './Elementals/ElementAccordion.vue'))
const ElementBackgroundImage = defineAsyncComponent(() => import(/* webpackChunkName 'ElementBackgroundImage': */ './Elementals/ElementBackgroundImage.vue'))
const ElementCTA = defineAsyncComponent(() => import(/* webpackChunkName 'ElementCTA': */ './Elementals/ElementCTA.vue'))
const ElementColours = defineAsyncComponent(() => import(/* webpackChunkName 'ElementColours': */ './Elementals/ElementColours.vue'))
const ElementContent = defineAsyncComponent(() => import(/* webpackChunkName 'ElementContent': */ './Elementals/ElementContent.vue'))
const ElementImages = defineAsyncComponent(() => import(/* webpackChunkName 'ElementImages': */ './Elementals/ElementImages.vue'))
const ElementImage = defineAsyncComponent(() => import(/* webpackChunkName 'ElementImage': */ './Elementals/ElementImage.vue'))
const ElementPercentage = defineAsyncComponent(() => import(/* webpackChunkName 'ElementPercentage': */ './Elementals/ElementPercentage.vue'))
const ElementProducts = defineAsyncComponent(() => import(/* webpackChunkName 'ElementProducts': */ './Elementals/ElementProducts.vue'))
const ElementLinks = defineAsyncComponent(() => import(/* webpackChunkName 'ElementLinks': */ './Elementals/ElementLinks.vue'))
const ElementTiles = defineAsyncComponent(() => import(/* webpackChunkName 'ElementTiles': */ './Elementals/ElementTiles.vue'))
const ElementVideo = defineAsyncComponent(() => import(/* webpackChunkName 'ElementVideo': */ './Elementals/ElementVideo.vue'))
const ElementForm = defineAsyncComponent(() => import(/* webpackChunkName 'ElementForm': */ './Elementals/ElementForm.vue'))


const ElementSplitSlider = defineAsyncComponent(() => import(/* webpackChunkName 'ElementSplitSlider': */ './Elementals/ElementSplitSlider.vue'))


// Form elements
const FormErrors = defineAsyncComponent(() => import(/* webpackChunkName 'FormErrors': */ './FormErrors/FormErrors.vue'))
const FormInput = defineAsyncComponent(() => import(/* webpackChunkName 'FormInput': */ './FormInput/FormInput.vue'))
const FormComposite = defineAsyncComponent(() => import(/* webpackChunkName 'FormComposite': */ './FormComposite/FormComposite.vue'))
const FormOptionSet = defineAsyncComponent(() => import(/* webpackChunkName 'FormOptionSet': */ './FormOptionSet/OptionSetField.vue'))
const FormCheckbox = defineAsyncComponent(() => import(/* webpackChunkName 'FormCheckbox': */ './FormCheckbox/FormCheckbox.vue'))
const FormCheckboxset = defineAsyncComponent(() => import(/* webpackChunkName 'FormCheckboxset': */ './FormCheckbox/FormCheckboxSet.vue'))
const FormTextarea = defineAsyncComponent(() => import(/* webpackChunkName 'FormTextarea': */ './FormTextarea/FormTextarea.vue'))
const FormFile = defineAsyncComponent(() => import(/* webpackChunkName 'FormFile': */ './FormFile/FormFile.vue'))
const FormSelect = defineAsyncComponent(() => import(/* webpackChunkName 'FormSelect': */ './FormSelect/FormSelect.vue'))
Vue.component('form-errors', FormErrors);
Vue.component('form-input', FormInput);
Vue.component('form-composite', FormComposite);
Vue.component('form-option-set', FormOptionSet);
Vue.component('form-checkbox', FormCheckbox);
Vue.component('form-checkboxset', FormCheckboxset);
Vue.component('form-textarea', FormTextarea);
Vue.component('form-file', FormFile);
Vue.component('form-select', FormSelect);




// Page specific components
// ==============================================

import BannerHome from "./Banners/BannerHome"
import BannerGeneric from "./Banners/BannerGeneric"
import BannerImage from "./Banners/BannerImage"
import BannerSplit from "./Banners/BannerSplit"
import BannerColour from "./Banners/BannerColour"
import BannerStudy from "./Banners/BannerStudy"
import Locations from "./Locations/Locations"

Vue.component("v-base", Base)
Vue.component("v-navigation", Navigation)
Vue.component("v-header", Header)
Vue.component("persona-full", PersonaFull)
Vue.component("v-footer", Footer)
Vue.component("v-moodboard-notification", MoodboardNotification)

export {
    Loader,
    BannerHome,
    BannerGeneric,
    BannerStudy,
    BannerImage,
    BannerSplit,
    BannerColour,
    SliderVertical,
    SliderHorizontal,
    ProductDrawer,
    ColourDrawer,
    Card,
    SampleCard,
    Colour,
    ColourCard,
    SampleColourCard,
    Cta,
    ModalInfo,
    ModalShare,
    ModalFullpage,
    PersonaFull,
    // Elements
    ElementAccordion,
    ElementBackgroundImage,
    ElementContent,
    ElementCTA,
    ElementColours,
    ElementLinks,
    ElementImage,
    ElementImages,
    ElementPercentage,
    ElementProducts,
    ElementSplitSlider,
    ElementTiles,
    ElementVideo,
    ElementForm,
    // End Elements
    UserForm,
    ContactForm,
    ContactFormSalesforce,
    SignUpForm,
    SampleForm,
    MagazineForm,
    Locations
}
